module.exports = __webpack_public_path__ + "img/market.8ac82670.svg";